// This file was automatically generated from print.idpConsent.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.idpConsent');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.idpConsent.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageBreak pageWrap"><h1 class="documentTitle" style="border: none">FCRA Compliance - Identity Proofing for Elation</h1><div><p style="padding-top: 15px">By clicking on the "I agree" button, you understand that immediately following this notice, you are providing \'written instructions\' to Elation under the Fair Credit Reporting Act authorizing Elation to obtain information from your personal credit profile or other information from Experian Health. You authorize Elation to obtain such information solely to confirm your identity to avoid fraudulent transactions in your name.</p><p style="padding-top: 15px">Electronically Signed by ', soy.$$escapeHtml(opt_data.physician.name), ' on ', (soy.$$escapeHtml(opt_data.now)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.now)) : ''), '</p></div></div>');
  if (!opt_sb) return output.toString();
};
